export const validUrlRegex = /^((http|https):\/\/)([a-zA-Z0-9-]+)(\.|:)([a-zA-Z0-9-]{2,}).*/gi;
